import { NavLink } from "react-router-dom";

function navClass(isActive) {
  return isActive ? "is-active" : undefined;
}

export default function HeaderHome() {
  return (
    <header className="site-header site-header--home">
      <div className="container">
        <NavLink className="logo logo--home" to="/" end>
          <span className="fresh">Fresh</span>
          <span className="claypot">ClayPot</span>
          <span className="curd">Curd</span>
        </NavLink>
        <nav className="nav-main" aria-label="Primary">
          <NavLink to="/" end className={({ isActive }) => navClass(isActive)}>
            Home
          </NavLink>
          {/* <NavLink to="/products" className={({ isActive }) => navClass(isActive)}>
            Products
          </NavLink> */}
          <NavLink to="/about" className={({ isActive }) => navClass(isActive)}>
            About Us
          </NavLink>
          <NavLink to="/legal" className={({ isActive }) => navClass(isActive)}>
            Terms & Conditions
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
